import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, OnInit, ViewEncapsulation } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ControlIdentity, CplaceBooleanControlChange, CplaceBooleanControlParameters } from '../../../api/model/models';
import { CplaceControlComponent, CPLACE_CONTROL_COMPONENT_VALUE_ACCESSOR } from '../shared';
import { CplaceControlService } from '../shared/cplace-control.service';

@UntilDestroy()
@Component({
  selector: 'cf-frontend-sdk-cplace-boolean-control',
  templateUrl: './cplace-boolean-control.component.html',
  styleUrls: ['./styles/cplace-boolean-control.component.scss'],
  providers: [CPLACE_CONTROL_COMPONENT_VALUE_ACCESSOR(CplaceBooleanControlComponent)],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CplaceBooleanControlComponent extends CplaceControlComponent<boolean> implements OnInit {
  public static readonly componentName = 'CplaceBooleanControlComponent';
  @HostBinding('class.cf-frontend-sdk-cplace-boolean-control') public cplaceBooleanControl = true;

  constructor(
    public elementRef: ElementRef<HTMLElement>,
    public changeDetectorRef: ChangeDetectorRef,
    public cplaceControlService: CplaceControlService
  ) {
    super(elementRef, changeDetectorRef, cplaceControlService);
  }

  public ngOnInit(): void {
    this.$value.pipe(untilDestroyed(this)).subscribe(() => {
      this.changeDetectorRef.detectChanges();
    });
  }

  protected initializeControlParameters(controlParameters: CplaceBooleanControlParameters): void {
    this.value = controlParameters.value;
  }

  protected getControlChange(identity: ControlIdentity, value: boolean): CplaceBooleanControlChange {
    return { featureName: identity.featureName, componentName: CplaceBooleanControlComponent.componentName, value: value };
  }

  protected getComponentClassName(): string {
    return CplaceBooleanControlComponent.componentName;
  }
}
